/*
 * @Author: ken yang
 * @Date: 2022-09-01 15:46:32
 * @LastEditTime: 2022-11-08 19:17:45
 * @LastEditors: ken yang
 * @Description: 全局指令的入口文件
 * @FilePath: /uexch_admin/src/utils/directive/index.js
 */
import hideText from './hideText.js'
import inModuleDirective from './inModule.js'
import to from './to.js'
import noNums from './noNums'
import bindDirective from './bindDirective'
import access from './access'

export default {
  install (app) {
    app.directive('hide', hideText)
    app.directive('inmodule', inModuleDirective)
    app.directive('to', to)
    app.directive('noNums', noNums)
    app.directive('bindDirective', bindDirective)
    app.directive('access', access)
  }
}
